import Vue from "vue";
import Vuex from "vuex";
// import errors from './modules/errors'
import search from "./modules/search";
import modals from "./modules/modals";

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        search,
        modals
    }
});
